import CommonContainer from './CommonContainer';
export default CommonContainer;
